export default {"src":"/_next/static/media/arrow-right.162bddb6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};